import { render } from "./vcorporatetransferlist.vue?vue&type=template&id=656c1634&scoped=true"
import script from "./vcorporatetransferlist.vue?vue&type=script&lang=js"
export * from "./vcorporatetransferlist.vue?vue&type=script&lang=js"

import "./vcorporatetransferlist.vue?vue&type=style&index=0&id=656c1634&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656c1634"]])

export default __exports__